import React, { ReactNode } from "react";
import {
  createTheme,
  alpha,
  ThemeProvider,
  StyledEngineProvider,
} from "@mui/material/styles";
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';

// Theme customization
// @see https://mui.com/customization/theming/

function remCalc(size:number) : string{
  return (size / 13 ) + 'rem';
}
const colors = {
  primary:{
    main: '#004165'
  },
  secondary: {
    main: '#A17700',
  },
  action: {
    main: '#A17700',
  },
}

export const uiTheme = createTheme({
  breakpoints: {
    values: {
      xs: 0,
      sm: 600,
      md: 960,
      lg: 1280,
      xl: 1400,
    },
  },
  typography: {
    fontFamily: "'Poppins', sans-serif",
  },
  palette: {
    primary: {
      main: colors.primary.main,
    },
    secondary: {
      main: colors.secondary.main,
    },
  },
  components: {
    MuiButton: {
      defaultProps: {
        disableElevation: true,
      },
      styleOverrides: {
        root: {
          borderRadius: 4,
          padding: "10px 20px"
        },
        outlined: {
          padding: "10px 20px"
        }
      }
    },
    MuiAccordionSummary: {
      styleOverrides: {
        root: {
          background: "#F9F9FB",
          padding: "0px 32px"
        }
      }
    },
    MuiFormControl: {
      styleOverrides: {
        root: {
          width: '100%',
        },
      }
    },
    MuiFormLabel: {
      styleOverrides: {
        root: {
          fontSize: remCalc(14),
          lineHeight: 1.33
        }
      }
    },
    MuiOutlinedInput: {
      styleOverrides: {
        notchedOutline: {
          fontSize: remCalc(14)
        },
        input: {
          padding: '14.5px 16px',
        },
        inputAdornedStart: {
          paddingLeft: '5px',
        }
      }
    },
    MuiInputLabel: {
      styleOverrides: {
        outlined: {
          transform: 'translate(14px, 13px) scale(1)',
          '&.MuiInputLabel-shrink': {
            transform: 'translate(14px, -9px) scale(0.75)'
          }
        }
      }
    },
    MuiChip: {
      styleOverrides: {
        root: {
          backgroundColor: alpha(colors.primary.main, 0.1),
          color: colors.primary.main,
        },
        deleteIcon: {
          color: colors.primary.main
        }
      }
    }
  },
});

type IPropsThemeWrap = {
  children: ReactNode
}

export const ThemeWrap = (props: IPropsThemeWrap) => {
  return (
    <StyledEngineProvider injectFirst>
      <ThemeProvider theme={uiTheme}>
        <LocalizationProvider dateAdapter={AdapterDateFns}>
          {props.children}
        </LocalizationProvider>
      </ThemeProvider>
    </StyledEngineProvider>
  );
}
